export class AppConfig {
  public static baseUrl = 'https://tejaapi.mbrats.in';
  public static UrlPath = AppConfig.baseUrl + '/api/v1';
  public static clientName = 'teja';
  public static clientPassword = 'r5CJ1DsNJG^xhzuoG&';
}
